import KendoWindow from '../KendoWindow'

let KendoWindowInstaller = class {
    static install(Vue) {
        Vue.component(KendoWindow.name, KendoWindow)
    }
}

export default KendoWindowInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(KendoWindowInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/kendo-window-installer/index.js